import CryptoJS from 'crypto-js';

/**
 *
 * @param {string} data is the string that needs to be decrypted
 * @returns jsonData is the object which is getting decrypted
 */
export const decoder = (data) => {
	let bytes = CryptoJS.AES.decrypt(data, process.env.REACT_APP_API_TOKEN_SECRET);
	let stringData = bytes.toString(CryptoJS.enc.Utf8);
	const jsonData = JSON.parse(stringData);
	return jsonData;
};


/**
 * Helper function to encode the given object using crypto-js
 * @param {object} object
 * @returns Encrypted string of the given object
 */
export const encoder = (object) => {
	// Convert the object to a JSON string
	const objStr = JSON.stringify(object);
	// encrypting the data
	const encryptData = CryptoJS.AES.encrypt(objStr, process.env.REACT_APP_API_TOKEN_SECRET).toString();

	return encryptData;
};